import React from "react";
import { Box, Skeleton, Typography, Card, CardContent, Stack } from "@mui/material";

const LoadingDetailsView = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Card>
        <CardContent>
          {/* Title */}
          <Skeleton variant="text" width="60%" height={40} />

          {/* Subtitle or secondary info */}
          <Skeleton variant="text" width="40%" height={30} sx={{ mb: 3 }} />

          {/* Detail rows */}
          <Stack spacing={2}>
            <Box>
              <Typography variant="body2" color="text.secondary">
                <Skeleton variant="text" width="30%" />
              </Typography>
              <Skeleton variant="text" width="80%" height={28} />
            </Box>

            <Box>
              <Typography variant="body2" color="text.secondary">
                <Skeleton variant="text" width="25%" />
              </Typography>
              <Skeleton variant="text" width="70%" height={28} />
            </Box>

            <Box>
              <Typography variant="body2" color="text.secondary">
                <Skeleton variant="text" width="35%" />
              </Typography>
              <Skeleton variant="text" width="65%" height={28} />
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoadingDetailsView;